import { Route, Routes } from 'react-router';
import { onQuitUsable } from '../../data/commands/quit';
import { onModuleUsable } from '../../data/moduleHooks';
import { registerTile } from '../../tiles/registry';
import { registerWebModule } from '../registry';
import { copy } from './copy';
import { QuitIcon } from './QuitIcon';
import { DayEditor } from './screens/DayEditor';
import { HistoryScreen } from './screens/HistoryScreen';
import { PlanRoute } from './screens/PlanRoute';
import { QuitDashboard } from './screens/QuitDashboard';
import { ShortcutLogRoute } from './screens/ShortcutLogRoute';
import { TriggersScreen } from './screens/TriggersScreen';
import { MoneySavedTile } from './tiles/MoneySavedTile';
import { QuitTodayTile } from './tiles/QuitTodayTile';
import { StreakTile } from './tiles/StreakTile';

/** Mounted by v0.1c's ModuleRoute at /m/quit_smoking/*, so these paths are relative. */
function QuitScreen() {
  return (
    <Routes>
      <Route index element={<QuitDashboard />} />
      <Route path="plan" element={<PlanRoute />} />
      <Route path="history" element={<HistoryScreen />} />
      <Route path="day/:date" element={<DayEditor />} />
      <Route path="triggers" element={<TriggersScreen />} />
      <Route path="log" element={<ShortcutLogRoute />} />
    </Routes>
  );
}

registerWebModule({
  id: 'quit_smoking',
  navLabel: copy.navLabel,
  Icon: QuitIcon,
  Screen: QuitScreen,
});

registerTile({
  type: 'quit.today',
  moduleId: 'quit_smoking',
  title: copy.cigarettesToday,
  sizes: ['small', 'wide'],
  defaultSize: 'small',
  defaultOnToday: true,
  Component: QuitTodayTile,
});

registerTile({
  type: 'quit.money-saved',
  moduleId: 'quit_smoking',
  title: copy.moneySavedTitle,
  sizes: ['small', 'wide'],
  defaultSize: 'small',
  Component: MoneySavedTile,
});

registerTile({
  type: 'quit.streak',
  moduleId: 'quit_smoking',
  title: copy.streakTitle,
  sizes: ['small', 'wide'],
  defaultSize: 'small',
  Component: StreakTile,
});

// Dashboard tiles and the Cigarettes category, whenever Quit Smoking becomes usable (toggle,
// admin forced_on, app start).
onModuleUsable('quit_smoking', onQuitUsable);
